import { Container } from 'react-bootstrap';
import Support from './Support';

const SupportDemo = () => {
  return (
    <Container>
      <Container className="mt-10">
        <h4>Support</h4>
        <Support />
      </Container>
    </Container>
  );
};

export default SupportDemo;
